/**
 * @file Configuration file for date ranges, locale settings, and table styling in the Kompack module
 * @module kompack/config
 * @description Contains date range presets, locale configuration for date formatting,
 *              and default styling for table headers used in the Kompack module
 */

import { LABELDAY, LABELMONTH } from '@/libs/filterDate'
import {
  firstDateOfMonth, lastDateOfMonth, lastDateOfLastMonth, lastMonth, lastWeek, today,
  last2,
  last7,
  last30,
  last90,
  firstDateOfYear,
} from '@/store/helpers'

/**
 * Locale configuration for date formatting
 * @type {Object}
 */
export const locale = {
  format: 'dd/mm/yyyy',
  daysOfWeek: LABELDAY,
  monthNames: LABELMONTH,
}

/**
 * Predefined date ranges for filtering
 * @type {Object}
 */
export const ranges = {
  'Semua Waktu': [new Date('2021-01-01'), today],
  'Bulan Ini': [firstDateOfMonth, today],
  'Bulan Lalu': [lastMonth(1), lastDateOfLastMonth],
  'Minggu Ini': lastWeek(0),
  'Minggu Lalu': lastWeek(1),
  'Custom Tanggal ': [today, today],
}

/**
 * Predefined date ranges for filtering with max date is today
 * @type {Object}
 */
export const rangesMaxIsToday = {
  'Semua Waktu': [new Date('2021-01-01'), last2],
  'Bulan Ini': [firstDateOfMonth, last2],
  'Bulan Lalu': [lastMonth(1), lastDateOfLastMonth],
  'Minggu Ini': [last7, last2],
  'Minggu Lalu': lastWeek(1),
  'Custom Tanggal ': [last2, last2],
}

/**
 * Predefined date ranges for filtering with max date can be customized
 * @param {Date} current - The current date, default is today
 * @returns {Object} - The predefined date ranges
 */
export const datePickerRangeGeneral = (current = today) => ({
  Kemarin: [last2, last2],
  '7 Hari Terakhir': [last7, current],
  '30 Hari Terakhir': [last30, current],
  '90 Hari Terakhir': [last90, current],
  '1 Tahun Terakhir': [firstDateOfYear, current],
  'Custom Tanggal ': [],
})

/**
 * Default class for table headers
 * @type {string}
 */
export const defaultThClass = 'font-[500] !capitalize'

/**
 * Default style object for table headers
 * @type {Object}
 */
export const defaultThStyle = {
  textTransform: 'capitalize',
  verticalAlign: 'middle',
  fontSize: '14px',
}
